export default __webpack_public_path__ + "static/media/WeD2.2107a6c0.png";